<template>
  <v-fade-transition>
    <div v-if="$userPermission.hasPermission('ROLE_UPLOAD_VACH')">
      <v-container class="custom importador_pond">
        <div class="pb-3">
          <v-switch v-model="enviarsft" color="primary" class="tipo_check mt-0" hide-details :label="$t('view.filetransaction.validator.form.enviarsft.label')" @change="change" />
        </div>
        <div>
          <file-pond
            ref="pond"
            :max-files="maxfiles"
            name="file"
            max-parallel-uploads="1"
            :label-file-loading="$t('view.commons.filepond.labelFileLoading')"
            :label-file-processing="$t('view.commons.filepond.labelFileProcessing')"
            :label-file-processing-complete="$t('view.commons.filepond.labelFileProcessingComplete')"
            :label-tap-to-retry="$t('view.commons.filepond.labelTapToRetry')"
            :label-idle="$t('view.commons.filepond.labelidle')"
            :label-invalid-field="$t('view.commons.filepond.labelInvalidField')"
            :label-file-processing-aborted="$t('view.commons.filepond.labelFileProcessingAborted')"
            :label-tap-to-cancel="$t('view.commons.filepond.labelTapToCancel')"
            :label-file-load-error="$t('view.commons.filepond.labelFileLoadError')"
            :label-file-processing-error="$t('view.commons.filepond.labelFileProcessingError')"
            :label-file-type-not-allowed="$t('view.commons.filepond.labelFileTypeNotAllowed')"
            :label-max-file-size-exceeded="$t('view.commons.filepond.labelMaxFileSizeExceeded')"
            :label-max-file-size="$t('view.commons.filepond.labelMaxFileSize')"
            file-validate-type-label-expected-types="Archivos válidos txt/csv"
            allow-file-size-validation="true"
            allow-multiple="true"
            drop-on-page="true"
            drop-on-element="false"
            accepted-file-types="text/plain, text/csv, application/vnd.ms-excel"
            :files="myFiles"
            :file-validate-type-detect-type="getCustomMIMEType"
            :server="{ process, revert, remove }"
            :on-download="download"
            :max-file-size="`${maxfilesize}MB`"
            @warning="warning"
            @error="error"
            @processfiles="processfiles" />
        </div>
      </v-container>
    </div>
  </v-fade-transition>
</template>
<script>
import FileTransactionAPI from "@/services/filetransaction/validator"; /** *******************************/
import combosAPI from "@/services/catalogos"; /** *******************************/
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { TIPO_ARCHIVO_NUM_CANAL, TIPO_ARCHIVO_NUM_DIM } from "@/constants/operativos";

export default {
  name: "ImportadorModule"
  , props: {
    maxfilesize: {
      default: 0
      , type: Number
    }
  }
  , data() {
    return {
      myFiles: []
      , maxfiles: "15"
      , maxnamelength: "80"
      , enviarsft: true
      , listadoArchivos: []
    };
  }
  , mounted() {
    this.clear();
    this.getFilesAccess();
    this.enviarsft = sessionStorage.getItem("enviarsft") == null ? true : sessionStorage.getItem("enviarsft") == "true";
  }
  , methods: {
    clear() {
      if (this.$refs.pond) this.$refs.pond.removeFiles();
      this.myFiles = [];
    }
    , async getFilesAccess() {
      const { data: { results: { combo: reponseListArchivos } } } = await combosAPI.get({ option: "archivos" });
      this.listadoArchivos = reponseListArchivos ? reponseListArchivos.filter((value) => value.status && [TIPO_ARCHIVO_NUM_CANAL, TIPO_ARCHIVO_NUM_DIM].includes(value.tipo)) : [];
    }
    , refreshDatatable() {
      this.$emit("reload");
    }
    , getCustomMIMEType(_source, type) {
      if (type === "application/vnd.ms-excel") type = "text/csv";
      return Promise.resolve(type);
    }
    , findFileToSendToValidate(nameFileUpload) {
      if (this.listadoArchivos && this.listadoArchivos.length > 0 && nameFileUpload && nameFileUpload !== "") {
        return this.listadoArchivos.find((itemFind) => nameFileUpload.startsWith(itemFind.name));
      } else {
        return null;
      }
    }
    , havePermissionToLoadFile(fileFinder) {
      if (!this.$userPermission.hasPermission("ROLE_ACCESO_TIPO_CANAL") && !this.$userPermission.hasPermission("ROLE_ACCESO_TIPO_DIM")) {
        return false;
      } else {
        switch (fileFinder.tipo) {
        case TIPO_ARCHIVO_NUM_CANAL:
          return !!this.$userPermission.hasPermission("ROLE_ACCESO_TIPO_CANAL");
        case TIPO_ARCHIVO_NUM_DIM:
          return !!this.$userPermission.hasPermission("ROLE_ACCESO_TIPO_DIM");
        }
      }
    }
    , validNameLength(name) {
      if (name.length > Number(this.maxnamelength)) {
        throw new Error(this.$t("view.commons.filepond.labelNameMaxChars").replaceAll(/{(\d+)}/g, this.maxnamelength));
      }
    }
    , validNameCharacters(name) {
      if (/[^A-Za-z0-9. _-]+/.test(name)) {
        throw new Error(this.$t("view.commons.filepond.labelNameCharacters"));
      }
    }
    , validNameFile(fileFinder) {
      if (!fileFinder) {
        throw new Error(this.$t("view.filetransaction.importer.errors.VL0000.text"));
      }
    }
    , validPermisions(fileFinder) {
      if (!this.havePermissionToLoadFile(fileFinder)) {
        throw new Error(this.$t("view.commons.filepond.labelNoPermission"));
      }
    }
    , process(_fieldName, file, _metadata, load, error, progress, abort) {
      try {
        const name = file.name;
        const formData = new FormData();
        let uploadFile = file;
        let fileFinder = this.findFileToSendToValidate(name);

        // El nombre no debe contener mas de X caracteres
        this.validNameLength(name);

        // El nombre no debe contener caracteres especiales
        this.validNameCharacters(name);

        // El nombre debe iniciar con el nombre del subtipo
        this.validNameFile(fileFinder);

        // Validamos si tiene Persos para cargar el tipo de Archivo
        this.validPermisions(fileFinder);

        // Construccion del formulario mock para request de subida de archivo
        formData.append("file", file);
        formData.append("enviarsft", this.enviarsft);

        // Construccion de request
        const request = new XMLHttpRequest();
        request.open("POST", "/api/filetransaction");
        request.setRequestHeader("Authorization", `Bearer ${this.$store.getters.getUserToken}`);
        request.upload.onprogress = (e) => {
          progress(e.lengthComputable, e.loaded, e.total);
        };

        request.onload = () => {
          this.mensajeErrorArchivo = "Ocurrió un error, intente nuevamente o compruebe sus permisos";
          if (request.status >= 200 && request.status < 300) {
            // the load method accepts either a string (id) or an object
            let response = JSON.parse(request.response);
            if (response.meta.code == "OK" && response.results) {
              uploadFile.clave = response.results;
              load(response.results.folio);
              this.refreshDatatable();
            } else {
              error(response.results.error);
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", "Error al subir archivo");
            }
          } else {
            error("Ocurrió un error al subir el archivo");
          }
        };
        request.send(formData);

        // Should expose an abort method so the request can be cancelled
        return {
          abort: () => {
            request.abort();
            abort();
          }
        };
      } catch (e) {
        error(e.message);
      }
    }
    , revert(_uniqueFileId, load) {
      load();
      return false;
    }
    , remove(_source, load) {
      load();
      return false;
    }
    , warning(error, file) {
      if ("Max files" == error.body) error.body = this.$t("view.commons.filepond.labelMaxFiles").replaceAll(/{(\d+)}/g, this.maxfiles);
      if (error && error.type) EventBus.$emit(events.SHOW_TOASTER_MESSAGE, error.type, "VL0000", error.body);
      setTimeout(() => {
        this.$refs.pond.removeFile(file.id);
      }, 6000);
    }
    , error(error, file) {
      if ("Max files" == error.body) error.body = this.$t("view.commons.filepond.labelMaxFiles").replaceAll(/{(\d+)}/g, this.maxfiles);
      if (error && error.type) EventBus.$emit(events.SHOW_TOASTER_MESSAGE, error.type, "VL0000", error.body);
      setTimeout(() => {
        this.$refs.pond.removeFile(file.id);
      }, 6000);
    }
    , async download(file) {
      const response = await FileTransactionAPI.download(file.clave);
      const url = globalThis.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", response.headers.filename); // or any other extension
      document.body.appendChild(link);
      link.click();
      link.remove();
      return link;
    }
    , processfiles() {
      this.processing = false;
      setTimeout(() => {
        FileTransactionAPI.exec();
        this.refreshDatatable();
        this.clear();
      }, 2000);
    }
    , change() {
      sessionStorage.removeItem("enviarsft");
      sessionStorage.setItem("enviarsft", this.enviarsft);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.importador_pond {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/filetransaction/validator/Uploader.vue